import script from "./StartingPointSection.vue?vue&type=script&setup=true&lang=js"
export * from "./StartingPointSection.vue?vue&type=script&setup=true&lang=js"

import "./StartingPointSection.vue?vue&type=style&index=0&id=40bf8797&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40bf8797"]])

export default __exports__